(() => {
  const headerHeartSelector = '[data-vtl-wishlist-header-snippet], [class*="Vtl-WishlistHeader"], .Vtl-WishlistIcon__Wrapper';

  // Capture clicks before the injected app opens its guest wishlist.
  window.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const heart = target.closest(headerHeartSelector);
    if (!heart || !heart.closest('.shopify-section--header')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const account = document.querySelector('.shopify-section--header .header__account-link shopify-account')
      || document.querySelector('.header-sidebar shopify-account');
    const avatar = account?.querySelector('[slot="signed-out-avatar"]');

    // The account component opens its sign-in sheet when its avatar is clicked.
    if (avatar) avatar.click();
    else if (account) account.click();
    else window.location.assign('/account/login');
  }, true);
})();
